export function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-7">
      <div>
        <h1 className="font-poppins font-bold text-2xl lg:text-3xl text-foreground">{title}</h1>
        {subtitle && <p className="text-muted-foreground text-sm mt-1 font-roboto">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
